import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = {
  key: 0,
  class: "qrcode-box"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 0,
  class: "mask"
}
const _hoisted_5 = {
  key: 1,
  class: "mask-text"
}
const _hoisted_6 = { key: 2 }
const _hoisted_7 = {
  key: 1,
  class: "payment-info"
}
const _hoisted_8 = {
  key: 2,
  class: "qrcode-loading"
}
const _hoisted_9 = { class: "text" }

import { ref, onMounted, watchEffect, PropType, onUnmounted, computed } from 'vue';
import { Row, Col, message } from 'ant-design-vue';
import { LoadingOutlined } from '@ant-design/icons-vue';
import QRCode from 'qrcode';
import { useOnline } from '@vueuse/core';
import { ISUBMIT_SOURCE, ORDER_STATUS } from '@/apis/common';
import { getOrderStatus, getOrderPayElement, getContractStatus, Status } from '@/apis';
import { ORDER_PAGE_STATUS, OrderInfo, CHANNEL } from '../utils/config';
import { getCurrentchannelType, handleResultStatus } from '../utils/method';


export default /*@__PURE__*/_defineComponent({
  __name: 'InPayment',
  props: {
  orderData: {
    type: Object as PropType<OrderInfo>,
    required: true,
  },
  isTimeout: {
    type: Boolean,
    required: true,
  },
  currentChannel: {
    type: Number,
    required: true,
  },
  changePaymentStatus: {
    type: Function as PropType<(status: ORDER_PAGE_STATUS) => void>,
    required: true,
  },
},
  setup(__props) {

/* eslint-disable @typescript-eslint/no-explicit-any */
const props = __props;
const {
  orderData: { orderNo, failRedirect, contractNo, succRedirect },
  isTimeout,
  currentChannel,
  changePaymentStatus,
} = props;

const codeurl = ref<string>('');
const errorText = ref<string>('二维码生成中...');
const orderErrorStatus = ref<boolean>(false);

// 处理支付时的提示文案
const shortText = computed(() => {
  const shortName = getCurrentchannelType(currentChannel)?.shortName;
  const hasQrcode = getCurrentchannelType(currentChannel)?.hasQrcode;

  if (hasQrcode) {
    return shortName + '扫码支付';
  }
  return shortName + '跳转支付';
});

// 是否是二维码支付
const isHasCode = computed(() => {
  if (
    currentChannel === CHANNEL.COMPANY_ONLINE_BANKING ||
    currentChannel === CHANNEL.SELF_ONLINE_BANKING
  ) {
    return false;
  }
  return true;
});

const generateQR = async (text: string) => {
  try {
    codeurl.value = await QRCode.toDataURL(text);
  } catch (err) {
    errorText.value = '二维码生成失败，请刷新后重新生成';
    // console.error(err);
  }
};

// 切换渠道
const changeChannel = () => {
  changePaymentStatus(ORDER_PAGE_STATUS.UNPAID);
};

// 轮询查订单状态
const getOrderStatusFn = async () => {
  // 请求查询订单状态，根据支付状态跳转到指定页面
  try {
    const { data } = await getOrderStatus({
      orderNo,
    });
    if (data) {
      if (data?.orderStatus === ORDER_STATUS.PAID) {
        message.success('订单已支付');
        setTimeout(() => {
          changePaymentStatus(ORDER_PAGE_STATUS.PAID);
        }, 500);
      } else if (data.orderStatus === ORDER_STATUS.CANCELLED) {
        message.info('订单已取消');
        setTimeout(() => {
          handleResultStatus(failRedirect);
        }, 500);
      } else {
        // 未支付
      }
    }
  } catch (error) {
    clearInterval(timer);
  }
};

// 请求查询签约状态
const getContractStatusFn = async () => {
  try {
    const { data } = await getContractStatus({
      contractNo,
    });
    if (data) {
      if (data?.status === Status.SIGNED || data?.status === Status.EFFECTIVE) {
        message.success('已成功签约');
        setTimeout(() => {
          handleResultStatus(succRedirect);
        }, 500);
      } else if (data?.status === Status.PRE_SIGNING) {
        //  正常未签约
      }
    }
  } catch (error) {
    console.error(error);
  }
};

// 开启定时器
const timer = setInterval(orderNo !== 'null' ? getOrderStatusFn : getContractStatusFn, 2000);

// 容错处理：接口报错 / 异常 / 无网络等情况
const handleOrderErrorStatus = () => {
  clearInterval(timer);
  const online = useOnline();
  orderErrorStatus.value = true;
  if (online.value) {
    errorText.value = '当前订单已取消无法继续支付，请重新下单！';
  } else {
    errorText.value = '网络异常，请检查网络状态';
  }
};

// 根据订单信息和选择渠道去获取生成的二维码
const getOrderInfo = async () => {
  const params = {
    channel: currentChannel,
    orderNo,
    contractNo,
    submitSource: currentChannel === CHANNEL.ALIPAY ? 'qrcode' : ISUBMIT_SOURCE.PC,
  };

  try {
    const { data } = await getOrderPayElement(params);
    if (data) {
      const {
        channelFactor: { codeUrl },
      } = data;
      if (isHasCode.value) {
        codeUrl ? generateQR(codeUrl) : clearInterval(timer);
      } else {
        // 跳转个人网银和企业网银
        window.open(codeUrl, '_blank');
      }
    } else {
      // 处理 data 为空的情况
      orderErrorStatus.value = true;
      errorText.value = '获取支付信息失败，请刷新重试';
      clearInterval(timer);
    }
  } catch (error: any) {
    // 容错处理：接口报错
    if (error.code === 20001) {
      handleResultStatus(succRedirect);
    } else if (error.code === 20002) {
      handleResultStatus(failRedirect);
    } else {
      handleOrderErrorStatus();
    }
  }
};

onMounted(() => {
  getOrderInfo();
});

onUnmounted(() => {
  clearInterval(timer);
});

watchEffect(() => {
  if (isTimeout) {
    clearInterval(timer);
    generateQR('timeout');
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Row), { align: "middle" }, {
      default: _withCtx(() => [
        _createVNode(_unref(Col), null, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              src: _unref(getCurrentchannelType)(_unref(currentChannel))?.img,
              class: "pay-icon"
            }, null, 8, _hoisted_1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Col), { class: "payment-title" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(shortText.value), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Col), {
          class: "change-type",
          onClick: changeChannel
        }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createTextVNode("切换其他支付方式")
          ])),
          _: 1,
          __: [0]
        })
      ]),
      _: 1
    }),
    (codeurl.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("img", {
            src: codeurl.value,
            width: "200",
            height: "200"
          }, null, 8, _hoisted_3),
          (_unref(isTimeout))
            ? (_openBlock(), _createElementBlock("div", _hoisted_4))
            : _createCommentVNode("", true),
          (_unref(isTimeout) || !codeurl.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, "二维码已失效"))
            : _createCommentVNode("", true),
          (_unref(currentChannel) === _unref(CHANNEL).ALL)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _cache[1] || (_cache[1] = [
                _createElementVNode("div", null, [
                  _createTextVNode(" 可以用以下渠道完成支付："),
                  _createElementVNode("span", { style: {"font-weight":"500"} }, "微信、支付宝、云闪付、主流银行app")
                ], -1)
              ])))
            : _createCommentVNode("", true)
        ]))
      : (!isHasCode.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _cache[3] || (_cache[3] = _createElementVNode("div", null, "请在新打开的网银页面完成支付", -1)),
            _createElementVNode("div", null, [
              _cache[2] || (_cache[2] = _createTextVNode("支付状态确认中 ")),
              _createVNode(_unref(LoadingOutlined))
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
            (!orderErrorStatus.value)
              ? (_openBlock(), _createBlock(_unref(LoadingOutlined), { key: 0 }))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_9, _toDisplayString(errorText.value), 1)
          ]))
  ], 64))
}
}

})